import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const TriangleArrowRight: React.FC<OneColorIconProps> = ({ className, color = 'core-oxide', size }) => {
  const hex = getHexColor(color)
  const height = size ?? 22
  const width = size ? Math.round((size * 9) / 22) : 9

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 9 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 11 0 21.392V.608L9 11Z" fill={hex} />
    </svg>
  )
}

export default TriangleArrowRight
